var _g, _g2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeactivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FF5956",
    height: 800,
    width: 800,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 23.9C5.8 24.9-.9 18.3.1 10.4.8 5.1 5.1.7 10.4.1c7.8-1 14.5 5.6 13.5 13.5-.7 5.3-5 9.6-10.3 10.3m.1-21.8C6.9 1 1 6.9 2.1 13.7c.7 4.1 4 7.5 8.2 8.2C17.1 23 23 17.1 21.9 10.3c-.7-4.1-4.1-7.5-8.2-8.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.6 4.2 14.2 14.1-1.4 1.5L4.2 5.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeactivate);
export default __webpack_public_path__ + "static/media/ic_deactivate.83b2f149dd85c240ad0268f76087c98b.svg";
export { ForwardRef as ReactComponent };